// extracted by mini-css-extract-plugin
export var dropZone = "index-module--drop-zone--fWn+W";
export var dropZoneActive = "index-module--drop-zone-active--MIkqx";